import { differenceInHours } from "date-fns"

const FALLBACK_LABEL = "Customer is waiting for a reply"

export function getWaitingForReplyLabel(
	waitingSince: string | number | Date | null | undefined,
	now: Date = new Date(),
): string {
	if (waitingSince === null || waitingSince === undefined) {
		return FALLBACK_LABEL
	}

	const parsed = new Date(waitingSince)
	if (isNaN(parsed.getTime())) return FALLBACK_LABEL

	const hours = differenceInHours(now, parsed)
	if (hours < 1) return FALLBACK_LABEL

	if (hours < 48) {
		return `Customer has been waiting ${hours}h for a reply`
	}

	return `Customer has been waiting ${Math.floor(hours / 24)}d for a reply`
}
